
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.63 90.24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke-width":".75","fill":"#7f4f16","stroke":"#7f4f16","stroke-miterlimit":"10","d":"M15.097 15.393l20.39 71.77-9.148 2.599-20.39-71.77zM67.668.458l20.39 71.77-9.148 2.6-20.39-71.77z"}}),_c('path',{attrs:{"stroke-width":".7978000000000001","fill":"#7f4f16","stroke":"#7f4f16","stroke-miterlimit":"10","d":"M.42 35.813L81.463 13.02l2.568 9.13L2.988 44.942zM10.117 70.411L91.16 47.618l2.568 9.13L12.684 79.54z"}})])
          )
        }
      }
    